// TODO (Nick 2026.04.29) - move this decompression logic to the backend so responses arrive already decompressed
import pako from 'pako';

const HTTP_HEADER_BODY_SEPARATOR = '\r\n\r\n';

export default function decompressGzipString(responseString) {
  const separatorIndex = responseString.indexOf(HTTP_HEADER_BODY_SEPARATOR);

  if (separatorIndex === -1) {
    return responseString;
  }

  const headers = responseString.slice(0, separatorIndex);
  const body = responseString.slice(separatorIndex + HTTP_HEADER_BODY_SEPARATOR.length);

  if (!hasGzipContentEncoding(headers)) {
    return responseString;
  }

  try {
    const bodyBytes = stringToBytes(body);
    const decompressed = pako.ungzip(bodyBytes, { to: 'string' });
    return headers + HTTP_HEADER_BODY_SEPARATOR + decompressed;
  } catch {
    return responseString;
  }
}

function hasGzipContentEncoding(headers) {
  return /Content-Encoding:\s*gzip/i.test(headers);
}

function stringToBytes(str) {
  const bytes = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i) & 0xff;
  }
  return bytes;
}
